import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Context } from "./Store";

function PrivateRoute({ component: Component, ...rest }) {
  
  const [store] = useContext(Context);

  // if driver is undefined, redirect to "/"
  return (
    <Route
      {...rest}
      render={(props) => store.driver.EMKey ? <Component {...props} /> : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
    />
  )
}

export default PrivateRoute;
